import { Outlet } from 'react-router-dom';
import React from 'react';

import { Alert, Stack, Typography } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { hasRole } from '@/helpers/permissions';
import { useAuth } from '@/contexts/auth';

interface PermissionRouteProps {
  allowedRoles: string[];
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ allowedRoles }) => {
  const { user } = useAuth();

  if (!hasRole(user?.role, allowedRoles)) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={3}
        sx={{ p: 6, minHeight: '60vh' }}
      >
        <Lock color="error" sx={{ fontSize: 64 }} />
        <Alert severity="error" sx={{ width: '100%', maxWidth: 520 }}>
          <Typography fontWeight="bold" gutterBottom>
            Acesso negado
          </Typography>
          <Typography variant="body2">
            Você não tem permissão para acessar esta página. <br /> Entre em
            contato com o administrador.
          </Typography>
        </Alert>
      </Stack>
    );
  }

  return <Outlet />;
};

export default PermissionRoute;
